

import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import CardContenedor from '../components/CardContenedor'
import { Volver } from '../components/Volver'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'
import { navegador } from '../functions/utils'
import { Alert, Button } from 'react-bootstrap';
import useAutorizacionSalida from '../hooks/useAutorizacionSalida';
import { Toaster } from 'react-hot-toast';


export default function AutorizacionSalida() {

    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const { formSalida, setFormSalida, cargando, jefes, alertaCamposRequeridos, guardarSalida,
    quienAutoriza, setQuienAutoriza, cargandoDocumento, cargandobtn, fecha, setFecha } = useAutorizacionSalida()
    const navegador_nombre = navegador()

    if (objLogueado.permitido !== "empleado") {
        window.location = "/"
        return (<></>)
    }


    return (
        <CardContenedor>
            <Volver />

            <div className='mb-2 mt-4 row d-flex flex-row'>
                <div className='col-12 col-md-5'>
                    <b>Nombre:</b>
                </div>
                <div className='col-12 col-md-7'>
                    {objLogueado.nombre} {objLogueado.apellido}
                </div>
            </div>

            <div className='mb-2 row d-flex flex-row'>
                <div className='col-12 col-md-5'>
                    <b>Fecha:</b>
                </div>
                <div className='col-12 col-md-7'>
                    <input type="date" className="form-control" value={fecha} onChange={e => setFecha(e.target.value)} />
                </div>
                {/* {hoy()} */}
            </div>


            <div className='mb-2 row d-flex flex-row'>
                <div className='col-12 col-md-5'>
                    <b>Área o dependencia administrativa:</b>
                </div>
                <div className='col-12 col-md-7'>
                    { cargando
                        ? 'Cargando...'
                        : <select className='form-control' value={quienAutoriza} onChange={e => setQuienAutoriza(e.target.value)}>
                            <option value={0} disabled>Selecciona una opción</option>
                            { jefes.map( (e,i) => <option key={i} value={e.pk_area}>{e.areas_adscripcion}</option>) }0
                        </select>
                    }
                </div>
            </div>


            <div className='mb-2 row d-flex flex-row'>
                <div className='col-12 col-md-5'>
                    <b>Motivo de la salida:</b>
                </div>
                <div className='col-12 col-md-7'>
                    <textarea
                        rows="3"
                        className="form-control"
                        placeholder='Escriba el motivo'
                        defaultValue={ formSalida.motivo }
                        id="exampleFormControlTextarea1"
                        onChange={ ({target}) => setFormSalida({ ...formSalida, motivo: target.value }) }
                    >
                        {/* { formSalida.motivo && '' } */}
                    </textarea>
                </div>
            </div>

            {/* { JSON.stringify(formSalida, null, 4) } */}

            <div className='mb-2 row d-flex flex-row'>
                <div className='col-12 col-md-5'>
                    <b>Hora de salida:</b>
                </div>
                <div className='col-12 col-md-7'>
                    {/* <input type='time' id='input_salida' className='form-control'/> */}
                    { navegador_nombre.includes('Firefox')
                    ? <TimePicker
                        showSecond={false}
                        className='form-control'
                        onChange={v => {
                            if (v) {
                                setFormSalida({ ...formSalida, hora_salida: v.format('H:mm') })
                            }
                        }}
                    />
                    : <input
                        type='time'
                        id='input_salida'
                        className='form-control'
                        onChange={v => {
                            if (v) {
                                setFormSalida({ ...formSalida, hora_salida: v.target.value })
                            }
                    }}/>}

                </div>
            </div>


            {/* <div className='mb-2 row d-flex flex-row'>
                <div className='col-12 col-md-5'>
                    <b>Hora de regreso:</b>
                </div>
                <div className='col-12 col-md-7'>
                    <TimePicker
                        showSecond={false}
                        className='form-control'
                        onChange={v => {
                            if (v) {
                                setFormSalida({ ...formSalida, hora_regreso: v.format('H:mm') })
                            }
                        }}
                    />
                </div>
            </div> */}

            <div className='d-flex justify-content-center mb-3'>
                <Button variant='primary' onClick={ guardarSalida } disabled={ cargandobtn }>
                    { cargandobtn ? 'Cargando...' : 'Guardar' }
                </Button>
            </div>

            { alertaCamposRequeridos && <div className='d-flex justify-content-center align-content-center'>
                <Alert variant='warning'>Hay campos vacíos.</Alert>
            </div> }

            { cargandoDocumento && <div className='d-flex justify-content-center align-content-center'>
                <Alert variant='info'>El documento se descargará en breve.</Alert>
            </div> }



            <Toaster/>
        </CardContenedor>
    )
}
